export enum AssetProviderUid {
  URL = 'url',
  SHUTTERSTOCK_ESSENTIALS = 'shutterstock-essentials',
  SHUTTERSTOCK_FULL = 'shutterstock-full',
  CLIPART = 'clipart',
  GETTY_IMAGES = 'getty-images',
}
